export const gossipEvents = [
  {
    id: 'evt-1001',
    title: '顶流男团成员深夜聚餐被拍 同框女生身份成谜',
    category: '情感',
    cover: 'https://readdy.ai/api/search-image?query=abstract%20warm%20amber%20and%20coral%20neon%20glow%20over%20a%20blurred%20city%20street%20crowd%20at%20night%2C%20cinematic%20entertainment%20atmosphere%2C%20editorial%20illustration%2C%20high%20contrast&width=800&height=600&seq=gossip-cover-01&orientation=landscape',
    heat: 986000,
    status: '反转更新',
    updateCount: 9,
    summary: '从深夜同框到工作室回应，再到女方好友发文，整件事已经反转两轮。目前双方各执一词，关键监控画面仍未公开。',
    latestTime: '今天 14:26',
    latestText: '女方好友发文称"只是普通朋友聚餐"，但网友翻出两人三个月前的同游照片。',
    tags: ['深夜同框', '工作室回应', '监控未公开'],
    timeline: [
      { time: '前天 22:40', kind: '起因', text: '路人拍到某顶流男团成员深夜与一名女生在餐厅包间聚餐。' },
      { time: '昨天 09:15', kind: '发酵', text: '相关照片冲上热搜第一，粉丝与路人开始对线。' },
      { time: '昨天 18:02', kind: '回应', text: '男方工作室发布声明，称"系多年好友聚会，请勿过度解读"。' },
      { time: '今天 11:30', kind: '反转', text: '疑似女方社交账号旧照被扒出，两人三个月前曾同游海岛。' },
      { time: '今天 14:26', kind: '最新', text: '女方好友发文回应"只是普通朋友聚餐"，但未解释同游照片。' },
    ],
  },
  {
    id: 'evt-1002',
    title: '古装大剧收官 男女主番位之争再起波澜',
    category: '影视',
    cover: 'https://readdy.ai/api/search-image?query=abstract%20cinematic%20spotlight%20on%20an%20empty%20theater%20stage%20with%20red%20velvet%20curtain%2C%20warm%20amber%20tones%2C%20dramatic%20editorial%20illustration%2C%20minimal%20composition&width=800&height=600&seq=gossip-cover-02&orientation=landscape',
    heat: 742000,
    status: '跟进中',
    updateCount: 5,
    summary: '剧集收官后，片方发布的致谢海报顺序引发粉丝不满，随后接连出现官微改图、演员本人点赞等连锁反应。',
    latestTime: '今天 10:08',
    latestText: '片方悄悄更换官微背景图，被指默认调整番位顺序。',
    tags: ['番位之争', '官微改图', '片方致谢'],
    timeline: [
      { time: '3天前 21:00', kind: '起因', text: '剧集收官，片方发布全员致谢海报，演员排序引发讨论。' },
      { time: '前天 13:20', kind: '发酵', text: '双方粉丝在超话展开激烈讨论，话题阅读量破两亿。' },
      { time: '昨天 16:45', kind: '回应', text: '制片人小号发文"排位不代表戏份"，随后秒删。' },
      { time: '今天 10:08', kind: '最新', text: '片方悄悄更换官微背景图，被指默认调整番位顺序。' },
    ],
  },
  {
    id: 'evt-1003',
    title: '音乐节假唱风波持续发酵 主办方终发声明',
    category: '音乐',
    cover: 'https://readdy.ai/api/search-image?query=abstract%20concert%20crowd%20silhouettes%20with%20warm%20golden%20stage%20light%20beams%20and%20haze%2C%20energetic%20live%20music%20atmosphere%2C%20editorial%20illustration&width=800&height=600&seq=gossip-cover-03&orientation=landscape',
    heat: 615000,
    status: '最新回应',
    updateCount: 6,
    summary: '现场观众质疑某歌手口型对不上，主办方与歌手团队先后回应，但双方说法存在明显出入。',
    latestTime: '今天 08:52',
    latestText: '主办方声明称"现场设备故障导致人声延迟"，与歌手团队的"全程真唱"说法相悖。',
    tags: ['假唱疑云', '主办方声明', '设备故障'],
    timeline: [
      { time: '2天前 23:10', kind: '起因', text: '现场观众上传视频，指出歌手口型与声音不同步。' },
      { time: '昨天 10:00', kind: '发酵', text: '多位现场观众跟帖，话题登上热搜。' },
      { time: '昨天 20:30', kind: '回应', text: '歌手团队发文"全程真唱，欢迎监督"。' },
      { time: '今天 08:52', kind: '最新', text: '主办方声明称设备故障导致人声延迟，与歌手团队说法相悖。' },
    ],
  },
  {
    id: 'evt-1004',
    title: '综艺剪辑争议升级 嘉宾工作室发长文回应',
    category: '综艺',
    cover: 'https://readdy.ai/api/search-image?query=abstract%20television%20studio%20warm%20amber%20and%20cream%20lighting%20with%20soft%20geometric%20shapes%2C%20modern%20broadcast%20editorial%20illustration%2C%20minimal%20aesthetic&width=800&height=600&seq=gossip-cover-04&orientation=landscape',
    heat: 528000,
    status: '跟进中',
    updateCount: 4,
    summary: '某嘉宾在节目中的片段被指"恶意剪辑"，工作室要求放出完整素材，节目组暂未正面回应。',
    latestTime: '昨天 22:15',
    latestText: '节目组内部人士称"剪辑符合播出规范"，工作室表示将继续沟通。',
    tags: ['恶意剪辑', '工作室发长文', '要求原片'],
    timeline: [
      { time: '4天前 20:00', kind: '起因', text: '节目播出后，嘉宾言行被指"前后矛盾"，引发争议。' },
      { time: '2天前 15:40', kind: '发酵', text: '粉丝对比路透，指出片段被重新拼接。' },
      { time: '昨天 22:15', kind: '最新', text: '嘉宾工作室发长文要求节目组放出完整素材，节目组暂未正面回应。' },
    ],
  },
  {
    id: 'evt-1005',
    title: '时尚盛典红毯造型引热议 造型师深夜被换',
    category: '时尚',
    cover: 'https://readdy.ai/api/search-image?query=abstract%20elegant%20fashion%20runway%20with%20warm%20gold%20and%20terracotta%20lighting%2C%20soft%20draped%20fabric%20shapes%2C%20luxury%20editorial%20illustration&width=800&height=600&seq=gossip-cover-05&orientation=landscape',
    heat: 402000,
    status: '已完结',
    updateCount: 3,
    summary: '红毯造型被吐槽后，艺人团队连夜更换造型师，事后双方均未再回应，事件逐渐平息。',
    latestTime: '前天 19:30',
    latestText: '原造型师删除相关动态，事件基本告一段落。',
    tags: ['红毯造型', '造型师更换', '团队沉默'],
    timeline: [
      { time: '5天前 19:00', kind: '起因', text: '盛典红毯造型被网友吐槽"不衬气质"。' },
      { time: '3天前 11:20', kind: '发酵', text: '有造型师圈内人爆料造型方案临时被改。' },
      { time: '前天 19:30', kind: '最新', text: '艺人团队连夜更换造型师，原造型师删除相关动态。' },
    ],
  },
  {
    id: 'evt-1006',
    title: '爱豆恋爱传闻反转再反转 双方否认后又被拍',
    category: '爱豆',
    cover: 'https://readdy.ai/api/search-image?query=abstract%20night%20city%20rooftop%20with%20warm%20orange%20fairy%20lights%20and%20bokeh%2C%20romantic%20moody%20atmosphere%2C%20editorial%20illustration%2C%20high%20contrast&width=800&height=600&seq=gossip-cover-06&orientation=landscape',
    heat: 356000,
    status: '反转更新',
    updateCount: 7,
    summary: '先是双方公司否认，紧接着又被拍到同进同出，粉丝态度出现分化，目前当事人仍未再发声。',
    latestTime: '今天 09:40',
    latestText: '狗仔放出新一期同进同出视频，双方公司未再回应。',
    tags: ['恋爱传闻', '公司否认', '再被拍'],
    timeline: [
      { time: '4天前 12:00', kind: '起因', text: '网友爆料两名爱豆疑似恋爱，附同款饰品对比。' },
      { time: '3天前 18:20', kind: '回应', text: '双方公司先后发声明否认恋情。' },
      { time: '昨天 21:10', kind: '反转', text: '狗仔放出两人深夜同进小区的画面。' },
      { time: '今天 09:40', kind: '最新', text: '新一期同进同出视频公开，双方公司未再回应。' },
    ],
  },
  {
    id: 'evt-1007',
    title: '女演员婚变传闻蔓延 经纪人一句话引爆猜测',
    category: '情感',
    cover: 'https://readdy.ai/api/search-image?query=abstract%20warm%20terracotta%20and%20cream%20abstract%20composition%20with%20flowing%20lines%20and%20soft%20grain%2C%20editorial%20art%20illustration%2C%20calm%20mood&width=800&height=600&seq=gossip-cover-07&orientation=landscape',
    heat: 288000,
    status: '跟进中',
    updateCount: 5,
    summary: '经纪人一句"以官方为准"被解读为默认，随后女演员本人出席活动状态引发新一轮讨论。',
    latestTime: '昨天 16:12',
    latestText: '女演员出席品牌活动未戴婚戒，被媒体追问时微笑不答。',
    tags: ['婚变传闻', '经纪人回应', '未戴婚戒'],
    timeline: [
      { time: '6天前 10:00', kind: '起因', text: '网友发现两人近三个月未同框互动。' },
      { time: '4天前 17:30', kind: '发酵', text: '经纪人回应"以官方为准"，被指默认。' },
      { time: '昨天 16:12', kind: '最新', text: '女演员出席活动未戴婚戒，被追问时微笑不答。' },
    ],
  },
  {
    id: 'evt-1008',
    title: '电影预售退票潮后续 片方紧急调整排片策略',
    category: '影视',
    cover: 'https://readdy.ai/api/search-image?query=abstract%20cinema%20hall%20with%20warm%20amber%20screen%20glow%20and%20rows%20of%20empty%20seats%2C%20cinematic%20editorial%20illustration%2C%20moody%20minimal&width=800&height=600&seq=gossip-cover-08&orientation=landscape',
    heat: 233000,
    status: '跟进中',
    updateCount: 4,
    summary: '预售退票率异常升高后，片方紧急调整排片并推出补偿方案，观众态度仍在观望。',
    latestTime: '昨天 13:05',
    latestText: '片方宣布对已购票观众发放额外观影券补偿。',
    tags: ['退票潮', '排片调整', '补偿方案'],
    timeline: [
      { time: '3天前 20:00', kind: '起因', text: '数据显示某影片预售退票率明显高于同期。' },
      { time: '2天前 14:10', kind: '发酵', text: '院线反映黄金场次上座率不及预期。' },
      { time: '昨天 13:05', kind: '最新', text: '片方紧急调整排片策略，并对已购票观众发放补偿观影券。' },
    ],
  },
];

export const headlineTicker = [
  '顶流男团深夜聚餐同框照曝光，工作室回应后又被扒出同游海岛',
  '古装大剧番位之争：片方悄悄更换官微背景图',
  '音乐节假唱风波升级，主办方声明与歌手团队说法相悖',
  '综艺剪辑争议持续，嘉宾工作室要求放出完整素材',
  '爱豆恋爱传闻再反转，新一期同进同出视频公开',
  '女演员出席活动未戴婚戒，婚变传闻再添新料',
];

export const hotRankList = [
  { rank: 1, id: 'evt-1001', title: '顶流男团深夜聚餐同框', heat: 986000, tag: '反转' },
  { rank: 2, id: 'evt-1002', title: '古装剧番位之争再起波澜', heat: 742000, tag: '跟进' },
  { rank: 3, id: 'evt-1003', title: '音乐节假唱风波主办方发声', heat: 615000, tag: '回应' },
  { rank: 4, id: 'evt-1004', title: '综艺剪辑争议升级', heat: 528000, tag: '跟进' },
  { rank: 5, id: 'evt-1005', title: '时尚盛典红毯造型引热议', heat: 402000, tag: '完结' },
  { rank: 6, id: 'evt-1006', title: '爱豆恋爱传闻被拍再反转', heat: 356000, tag: '反转' },
];

export const categories = ['全部', '情感', '影视', '音乐', '综艺', '爱豆', '时尚'];